import { RouteConfig, Route } from 'vue-router';
import Layout from '@/layout/index.vue';
import { ALL_ROLES } from '@/utils/permission';

const bookingRoutes: RouteConfig = {
  path: '/booking',
  component: Layout,
  redirect: '/booking/search',
  meta: {
    title: 'Booking',
    icon: 'mdi-calendar-range',
    alwaysShow: true,
  },
  children: [
    {
      path: 'search',
      component: () =>
        import(
          /* webpackChunkName: "booking" */ '@/views/booking/search/index.vue'
        ),
      name: 'booking-search',
      meta: {
        title: 'Booking search',
        icon: 'mdi-book-search',
      },
      children: [
        {
          path: 'result',
          component: () =>
            import(
              /* webpackChunkName: "booking" */ '@/views/booking/search/result/index.vue'
            ),
          name: 'booking-search-result',
          meta: {
            title: 'Booking search result',
            icon: 'mdi-table-search',
            hidden: true,
            noCache: true,
          },
          props: (route: Route) => ({
            ...route.query,
          }),
        },
      ],
    },
    {
      path: ':id',
      component: () =>
        import(
          /* webpackChunkName: "booking" */ '@/views/booking/detail/index.vue'
        ),
      name: 'booking-detail',
      meta: {
        title: 'Booking detail',
        icon: 'mdi-account-card-details',
        hidden: true,
      },
      props: route => ({
        bookingId: route.params.id,
      }),
    },
  ],
};

export default bookingRoutes;
